import type { WorkspaceAppManifest } from './workspaceManifest';

export const APP_MANIFEST = {
    appId: 'pra-workspace',
    permissionsPrefix: 'pra',
    displayName: 'PRA Smart',

    navSections: [
        { key: 'dashboard', label: 'Dashboard', route: '/pra/dashboard' },
        { key: 'sales',     label: 'Sales',     route: '/pra/sales' },
        { key: 'reports',   label: 'Reporting', route: '/pra/reports' },
        { key: 'customers', label: 'Customers', route: '/pra/customers' },
        { key: 'catalog',   label: 'Catalog',   route: '/pra/catalog' },
    ],

    resources: [
        {
            key: 'praInvoices',
            label: 'PRA Invoices',
            navSection: 'sales',
            recordRuleFields: [
                { field: 'CompanyId', operators: ['eq'] },
                { field: 'Status', operators: ['eq', 'neq', 'in', 'notin'] },
            ],
        },
        {
            key: 'praSalesTaxReturnReport',
            label: 'PRA sales tax return report',
            navSection: 'reports',
        },
        {
            key: 'customers',
            label: 'Customers',
            navSection: 'customers',
            recordRuleFields: [
                { field: 'CompanyId', operators: ['eq'] },
                { field: 'IsActive', operators: ['eq'] },
            ],
        },
        { key: 'products',        label: 'Products',        navSection: 'catalog' },
        { key: 'productProfiles', label: 'Product profiles', navSection: 'catalog' },
        { key: 'fbrSalesTaxRates',label: 'Sales tax rates', navSection: 'catalog' },
        { key: 'companies',       label: 'Companies',        navSection: 'catalog' },
        { key: 'categories',      label: 'Categories',       navSection: 'catalog' },
        { key: 'reviews',         label: 'Reviews',          navSection: 'catalog' },
    ],
} satisfies WorkspaceAppManifest;
